import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import 'es6-promise/auto'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueCookieAcceptDecline from "vue-cookie-accept-decline";
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
Vue.component("vue-cookie-accept-decline", VueCookieAcceptDecline);

Vue.config.productionTip = false

Vue.use(Vuex)

//Vue.use(BootstrapVue)
//Vue.use(IconsPlugin)

const store = new Vuex.Store({
  state:{
    count:0
  },
  mutations:{
    increment(state){
      state.count++
    }
  }
});

store.commit('increment');
console.log(store.state.increment);

new Vue({
  render: h => h(App),
}).$mount('#app')
